<template>
  <div>

    <Spinner v-if="loading === true" />

    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button" />
    </div>
    <component is="b-card">
      <b-tabs
        v-if="true"
        pills
      >
        <!-- Tab: Account -->
        <b-tab
          active
          @click="catchTab('general_settings')"
        >
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">General Settings</span>
          </template>
          <div class="mt-2 pt-75">
            <general :tab="currentTab" />
          </div>
        </b-tab>

        <!-- Tab: Design Types -->
        <b-tab @click="catchTab('design_types')">
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Design Types</span>
          </template>
          <div class="mt-2 pt-75">
            <design-types :tab="currentTab" />
          </div>
        </b-tab>

        <!-- Tab: Stages & Phases -->
        <b-tab @click="catchTab('project_status')">
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Project Status & Types</span>
          </template>
          <div class="mt-2 pt-75">
            <project-status :tab="currentTab" />
          </div>
        </b-tab>
        <b-tab @click="catchTab('stages')">
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Stages</span>
          </template>
          <div class="mt-2 pt-75">
            <stages :tab="currentTab" />
          </div>
        </b-tab>
        <b-tab @click="catchTab('phases')">
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Phases</span>
          </template>
          <div class="mt-2 pt-75">
            <phases :tab="currentTab" />
          </div>
        </b-tab>
      </b-tabs>
    </component>
  </div>
</template>

<script>
import {
  BTab, BTabs, BCard,
} from 'bootstrap-vue'
import General from './general/index.vue'
import DesignTypes from './designTypes/index.vue'
import ProjectStatus from './projectStatus/index.vue'
import Stages from './stages/index.vue'
import Phases from './phases/index.vue'

import Spinner from '@/shared/loader/Spinner'

export default {
  components: {
    Spinner,
    BTab,
    BTabs,
    BCard,
    General,
    DesignTypes,
    ProjectStatus,
    Stages,
    Phases,
  },
  data() {
    return {
      loading: false,
      currentTab: 'general_settings',
    }
  },
  methods: {
    catchTab(tab) {
      this.currentTab = tab
      console.log('currentTab ===>', this.currentTab)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
